export const iconFontAwesomeUsersPeoplePersonBurst = (
	<i className="fa-solid fa-person-burst"></i>
);
